import React, { RefObject } from "react";

import {
    RouteComponentProps,
    withRouter
} from "react-router-dom";

import {
    Box,
    Divider,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";

import { Trans, } from "@lingui/macro";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from "@mui/icons-material/Logout";

import { ZPlayNetworkService } from "commons/zplay-network-service";

import { AccountMenuState, AccountMenuProps } from "./models";
import AuthenticationService from "services/authentication-service";

class AccountMenu extends React.Component<AccountMenuProps & RouteComponentProps<any>, AccountMenuState> {

    private readonly selectAcRef: RefObject<HTMLInputElement> = React.createRef();

    constructor(props: any) {

        super(props);

        this.state = {
            loggedOut: false,
            anchorAc: null
        };
    }

    private openAccountSelect = (event: React.MouseEvent<HTMLDivElement>) => {
        this.setState(() => ({ anchorAc: this.selectAcRef.current }));
    };

    private closeAccountSelect = () => {
        this.setState(() => ({ anchorAc: null }));
    }

    private goToBackoffice = () => {

        this.closeAccountSelect();

        let { history } = this.props
        history.push("/backoffice/choose-action");
    };

    private goToPrivateAccount = () => {
        
        this.closeAccountSelect();

        let { history } = this.props
        history.push("/user-profile");
    }

    private logout = () => {

        AuthenticationService.logout(this.logoutCallback, this.logoutCallback);
    }

    private logoutCallback = () =>{
        localStorage.removeItem("current_user");
        localStorage.removeItem(ZPlayNetworkService.REFRESH_TOKEN_KEY || "refresh_token");
        localStorage.removeItem(ZPlayNetworkService.TOKEN_KEY || "token");

        this.setState(() => ({
            loggedOut: true
        }))

        window.location.reload();
        return
    }

    render() {
        return (         
            <Box ref={this.selectAcRef} sx={{cursor: "pointer"}}>
                <Stack direction="row" onClick={(event) => this.openAccountSelect(event)}>
                    <Typography><Trans id="header-hello">Ciao,</Trans> {this.props.username}</Typography>
                    {this.state.anchorAc ? <ArrowDropUpIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
                </Stack>
                <Menu
                    className="menu-appbar"
                    anchorEl={this.state.anchorAc}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={Boolean(this.state.anchorAc)}
                    onClose={this.closeAccountSelect} 
                >

                    {!this.props.backofficeMode && <>
                        <MenuItem 
                            onClick={this.goToBackoffice} 
                            sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}
                        >
                            <ListItemIcon>
                                <ManageAccountsIcon fontSize="small" sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}/>
                            </ListItemIcon>
                            <ListItemText>
                                <Trans id="header-backoffice-select">Backoffice</Trans>
                            </ListItemText>
                        </MenuItem>
                        <MenuItem 
                            onClick={this.goToPrivateAccount} 
                            sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}
                        >
                            <ListItemIcon>
                                <PersonIcon fontSize="small" sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}/>
                            </ListItemIcon>
                            <ListItemText>
                                <Trans id="header-profile-select">Il mio profilo</Trans>
                            </ListItemText>
                        </MenuItem>
                        <Divider variant={"middle"} sx={{ bgcolor: "#535353" }} />
                    </>}
                    <MenuItem 
                        onClick={this.logout} 
                        sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}
                    > 
                        <ListItemIcon>
                            <LogoutIcon fontSize="small" sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}/>
                        </ListItemIcon>
                        <ListItemText>
                            <Trans id="header-logout-select">Logout</Trans>
                        </ListItemText>
                    </MenuItem>
                </Menu>
            </Box>
        )
    }
}

export default withRouter(AccountMenu);